import cn from 'classnames';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Layout } from '@sravni/react-design-system';
import { PreFooter } from '@sravni/react-pre-footer';
import type { Seo } from '@sravni/types/lib/seo';

import { Breadcrumbs } from '@src/components/Breadcrumbs';
import { usePageContext } from '@src/config';
import { getCreditsLists } from '@src/reducers/microcredits';
import { useHasUtmLabel } from '@src/reducers/route';
import { isMainPage, isSpecialPage } from '@src/utils/routing';

import { Disclaimer, DisclaimerBranding } from './Disclaimer';
import { SeoBlocks } from './SeoBlocks';
import styles from './styles.module.scss';

interface IProps {
    className?: string;
    seo: Seo;
    breadcrumbs?: Seo['breadcrumbs'];
    prefooter?: Seo['prefooter'];
}

const SeoComponents: FC<IProps> = memo(({ className, seo, breadcrumbs = [], prefooter = [] }) => {
    const { asPath, query } = useRouter();
    const isRenderDisclaimer = isMainPage(asPath, query) || isSpecialPage(asPath, query);

    const { listKey } = usePageContext();
    const { items } = useSelector(getCreditsLists)[listKey] || { items: [] };
    const hasUtmLabel = useHasUtmLabel();

    if (!isRenderDisclaimer && hasUtmLabel) {
        return null;
    }

    return (
        <div className={cn(styles.container, className)}>
            {!hasUtmLabel && (
                <Layout className={styles.layout}>
                    <SeoBlocks contentBlocks={seo} items={items} />
                </Layout>
            )}

            {isRenderDisclaimer && (
                <Layout className={cn({ [styles.utm]: hasUtmLabel })}>
                    <Disclaimer />
                    <DisclaimerBranding />
                </Layout>
            )}

            {!hasUtmLabel && <Breadcrumbs items={breadcrumbs} />}

            {!hasUtmLabel && <PreFooter columns={prefooter} className={styles.prefooter} />}
        </div>
    );
});

export default SeoComponents;
